/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @next/next/no-img-element */

// const redis = new Redis({
//   url: process.env.UPSTASH_REDIS_REST_URL,
//   token: process.env.UPSTASH_REDIS_REST_TOKEN,
// });
import { useStyles } from "./styles";
import "./override.css";
import { useLocation } from "react-router-dom";

export default function SuccessUploadShare({ res = null }: any) {
  const location = useLocation();
  const { type, fileUrl, ipaUrl } = location.state || {};
  if (type === undefined) {
    return (
      <>
        <div>
          <title>DropNInstall</title>
          <meta
            name="description"
            content="Upload and share APK/IPA apps easily with QR codes and instant links."
          />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <link rel="icon" href="/favicon.ico" />
        </div>
        <div className="container">
          <header className="header">
            <h1>🚀 Quickly Upload & Share</h1>
            <p>
              📱 Upload your .apk or .ipa file. 🔗 Get a link. 📷 Share with QR.
            </p>
          </header>
          <div className="message">Invalid or expired link.</div>
        </div>
      </>
    );
  }

  // const { fileUrl, type } = res;

  return (
    <>
      <div>
        <title>DropNInstall</title>
        <meta
          name="description"
          content="Upload and share APK/IPA apps easily with QR codes and instant links."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </div>
      <div className="container">
        <header className="header">
          <h1>🚀 Quickly Upload & Share</h1>
          <p>
            📱 Upload your .apk or .ipa file. 🔗 Get a link. 📷 Share with QR.
          </p>
        </header>

        <div className="details-container">
          <div className="details-box">
            <h2>📱 App Details</h2>
            <ul>
              <li>
                <strong>Platform:</strong>{" "}
                {type === "ipa" ? "iOS (.ipa)" : "Android (.apk)"}
              </li>
              <li>
                <strong>Install Method:</strong>{" "}
                {type === "ipa"
                  ? "Tap 'Allow' > Home Screen > Install"
                  : "Tap to install (may require allowing unknown sources)"}
              </li>
            </ul>
            <div className="text-center mt-4">
              {`Download ${type === "ipa" ? "iOS" : "Android"} App: `}
              <a href={`${fileUrl}`} className="download-link">
                {fileUrl}
              </a>
            </div>

            <div className="mt-4">
              <img
                src={`https://api.qrserver.com/v1/create-qr-code/?data=${encodeURIComponent(
                  fileUrl
                )}&size=150x150`}
                alt="Scan QR Code"
                className="qr-code"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export const getServerSideProps: GetServerSideProps = async (context) => {
//   const { id } = context.params as { id: string };

//   try {
//     const res = await redis.get(id);
//     return {
//       props: {
//         res,
//       },
//     };
//   } catch (error) {
//     console.error("Error fetching file data:", error);
//     return {
//       props: {
//         res: null,
//       },
//     };
//   }
// };
